/** @format */

import React, { useState, useEffect } from 'react'

import { queryRecommendWordsList, queryRecommendWords, updateRecommendWords, updateCaseHomepageRight, caseClearRedis } from '../../api'

import { Table, Button, Modal, Input, message, Switch } from 'antd'

import './index.less'
import { setUseProxies } from 'immer'

const typeMap = ['', '国外', '国内']

// eslint-disable-next-line import/no-anonymous-default-export
export default () => {
  const [recommendList, setRecommendList] = useState([])

  const [editData, setEditData] = useState()
  const [editSort, setEditSort] = useState()
  const [editWord, setEditWord] = useState()
  const [editUrl, setEditUrl] = useState()
  const [editDelStatus, setEditDelStatus] = useState(0)
  const [showChecked, setShowChecked] = useState(false)


  // status
  const [editVisible, setEditVisible] = useState(false)
  const [listLoading, setListLoading] = useState(false)

  const columns = [
    {
      title: '序值',
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: '名称',
      dataIndex: 'word',
      key: 'word',
      width: '15%'
    },
    {
      title: '跳转链接',
      dataIndex: 'url',
      key: 'url',
    },
    {
      title: '维护时间',
      dataIndex: 'updateTime',
      key: 'updateTime',
      width: '15%'
    },
    {
      title: '是否展示',
      dataIndex: 'delStatus',
      key: 'delStatus',
      render: (t, d, index) => {
        if (d.delStatus == 0) {
          return '是'
        } else {
          return '否'
        }
      }
    },

    {
      title: '操作',
      dataIndex: '',
      key: 'operation',
      render: (t, d, index) => (
        <Button
          className='editBtn'
          onClick={() => {
            let params = {
              id: d.id,
              url: d.url,
              word: d.word
            }
            queryRecommendWords(params).then(res => {
              if (res?.error?.errorCode == 0 + '') {
                setEditSort(res.data.sort)
                setEditWord(res.data.word)
                setEditUrl(res.data.url)
                setEditDelStatus(res.data.delStatus)
              } else {
                message.info(res?.error?.errorMsg)
              }
            }).finally(() => {
              setEditVisible(true)
              setEditData(d)
            })

          }}
        >
          编辑
        </Button>
      ),
    },
  ]
  useEffect(() => {
    reqRecommendList()
  }, [])

  const handleEdit = () => {
    if (editUrl == '' || editWord == '') {
      message.error('名称或跳转链接不可为空')
      return
    }
    if (editData) {
      setEditVisible(false)
      updateRecommendWords({
        id: editData.id,
        url: editUrl,
        word: editWord,
        delStatus: editDelStatus
      })
        .then((res) => {
          if (res?.error?.errorCode == 0) {
            message.success('修改成功')
          } else {
            message.error(res?.data)
          }
        })
        .finally(() => {
          reqRecommendList()
        })
    }
  }

  const reqRecommendList = () => {
    setListLoading(true)
    queryRecommendWordsList()
      .then((res) => {
        if (res?.error?.errorCode == 0) {
          setListLoading(false)
          setRecommendList(res?.data)
        }
      })
      .finally(() => {
        setListLoading(false)
      })
  }

  const handleCloseEditModal = () => {
    setEditVisible(false)
    setEditData(undefined)
  }

  const changeSwitch = (value) => {
    setEditDelStatus(value ? 0 : 1)
  }
  useEffect(() => {
    if (editDelStatus == 0) {
      setShowChecked(true)
    } else {
      setShowChecked(false)
    }

  }, [editDelStatus])
  return (
    <div className='caseHomeRecommendContainer'>
      <h2>为您推荐管理</h2>
      <Table
        loading={listLoading}
        columns={columns}
        dataSource={recommendList}
        pagination={false}
      />
      <Modal
        visible={editVisible}
        wrapClassName='img_modal'
        title='编辑为您推荐词'
        okText='保存'
        cancelText='取消'
        onOk={handleEdit}
        onCancel={handleCloseEditModal}
      >
        <div className='caseEditModalContainer'>
          <div className='editRow'>
            <div className='label'>序值：</div>
            <Input
              value={editSort}
              onChange={(e) => setEditSort(e.target.value)}
              className='value'
              disabled
            />
          </div>
          <div className='editRow'>
            <div className='label'>名称：</div>
            <Input
              value={editWord}
              onChange={(e) => setEditWord(e.target.value)}
              className='value'
            />
          </div>
          <div className='editRow'>
            <div className='label'>跳转链接：</div>
            <Input
              value={editUrl}
              onChange={(e) => setEditUrl(e.target.value)}
              className='value'
            />
          </div>
          <div className='editRow'>
            <div className='label'>是否展示：</div>
            <Switch defaultChecked={showChecked} key={showChecked} onChange={changeSwitch} />
          </div>
        </div>
      </Modal>
    </div>
  )
}